import { render, staticRenderFns } from "./TriggerBroadcasts.vue?vue&type=template&id=125e3eb0&scoped=true&"
import script from "./TriggerBroadcasts.vue?vue&type=script&lang=ts&"
export * from "./TriggerBroadcasts.vue?vue&type=script&lang=ts&"
import style0 from "./TriggerBroadcasts.vue?vue&type=style&index=0&id=125e3eb0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125e3eb0",
  null
  
)

export default component.exports